import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	purchaseOrderList: {
		requesting: false,
		items: [],
		pagination: {
			current_page: 1,
			per_page: 10,
			total: 0,
		},
		error: null,
		success: false,
		filters: {},
	},

	purchaseOrderDetails: {
		requesting: false,
		data: null,
		error: null,
		success: false,
	},
}

export const purchaseOrderSlice = createSlice({
	name: 'purchaseOrder',

	initialState,

	reducers: {

		getPurchaseOrderList: (state, action) => {
			state.purchaseOrderList.requesting = true
			state.purchaseOrderList.error = null
			state.purchaseOrderList.items = []
			state.purchaseOrderList.success = false
			state.purchaseOrderList.filters = action.payload
		},

		getPurchaseOrderListSuccess: (state, action) => {
			const { data,	current_page, per_page, total } = action.payload
			state.purchaseOrderList.requesting = false
			state.purchaseOrderList.items = data
			state.purchaseOrderList.success = true
			state.purchaseOrderList.pagination.current_page =current_page
			state.purchaseOrderList.pagination.per_page = per_page
			state.purchaseOrderList.pagination.total = total
		},

		getPurchaseOrderListFail: (state, action) => {
			state.purchaseOrderList.requesting = false
			state.purchaseOrderList.error = action.payload
		},

		getPurchaseOrderDetails: (state) => {
			state.purchaseOrderDetails.requesting = true
			state.purchaseOrderDetails.error = null
			state.purchaseOrderDetails.success = false
		},

		getPurchaseOrderDetailsSuccess: (state, action) => {
			state.purchaseOrderDetails.requesting = false
			state.purchaseOrderDetails.data = action.payload
			state.purchaseOrderDetails.success = true
		},

		getPurchaseOrderDetailsFail: (state, action) => {
			state.purchaseOrderDetails.requesting = false
			state.purchaseOrderDetails.error = action.payload
		},

		doPurchaseOrderCreate: (state) => {
			state.purchaseOrderDetails.requesting = true
			state.purchaseOrderDetails.error = null
			state.purchaseOrderDetails.data = null
			state.purchaseOrderDetails.success = false
		},

		doPurchaseOrderCreateSuccess: (state, action) => {
			state.purchaseOrderDetails.requesting = false
			state.purchaseOrderDetails.data = action.payload
			state.purchaseOrderDetails.success = true
		},

		doPurchaseOrderCreateFail: (state, action) => {
			state.purchaseOrderDetails.requesting = false
			state.purchaseOrderDetails.error = action.payload
			state.purchaseOrderDetails.success = false
		},

		doPurchaseOrderUpdate: (state) => {
			state.purchaseOrderDetails.requesting = true
			state.purchaseOrderDetails.error = null
			state.purchaseOrderDetails.data = null
			state.purchaseOrderDetails.success = false
		},

		doPurchaseOrderUpdateSuccess: (state, action) => {
			state.purchaseOrderDetails.requesting = false
			state.purchaseOrderDetails.data = action.payload
			state.purchaseOrderDetails.success = true
		},

		doPurchaseOrderUpdateFail: (state, action) => {
			state.purchaseOrderDetails.requesting = false
			state.purchaseOrderDetails.error = action.payload
			state.purchaseOrderDetails.success = false
		},

		doPurchaseOrderDelete: (state) => {
			state.purchaseOrderDetails.requesting = true
			state.purchaseOrderDetails.error = null
			state.purchaseOrderDetails.data = null
			state.purchaseOrderDetails.success = false
		},

		doPurchaseOrderReset: (state) => {
			state.purchaseOrderDetails.data = null
		},

	},
})

export const {
	getPurchaseOrderList, getPurchaseOrderListSuccess,
	getPurchaseOrderListFail, getPurchaseOrderDetails,
	getPurchaseOrderDetailsSuccess, getPurchaseOrderDetailsFail,
	doPurchaseOrderCreate, doPurchaseOrderCreateSuccess,
	doPurchaseOrderCreateFail, doPurchaseOrderUpdate,
	doPurchaseOrderUpdateSuccess, doPurchaseOrderUpdateFail,
	doPurchaseOrderDelete, doPurchaseOrderReset,
} = purchaseOrderSlice.actions

export default purchaseOrderSlice.reducer